module.exports = __webpack_public_path__ + "static/media/molto_richiesto.d5f378a7.png";